import { DatePicker } from 'antd';
import { AppForm, AppFormItem, formRules } from 'shared/UI/UIKit/Form';
import { AppSelect } from 'shared/UI/UIKit/Select';
import { AppInput } from 'shared/UI/UIKit/Input';
import { USER_DATE_FORMAT } from 'shared/constants/date';
import type { AppFormInstance } from 'shared/UI/UIKit/Form';
import type { Month } from '../../types';
import { getDateConstraints } from '../lib';

export interface DateFormProps {
  form: AppFormInstance;
  calendarYear: string;
  calendarMonth: Month;
}

const dateTypeOptions = [
  { label: 'Выходной день', value: 'true' },
  { label: 'Рабочий день', value: 'false' },
];

export const DateForm = ({ form, calendarYear, calendarMonth }: DateFormProps) => {
  return (
    <AppForm form={form}>
      <AppFormItem rules={formRules.requiredDate} label="Дата" name="date">
        <DatePicker
          {...getDateConstraints(calendarYear, calendarMonth)}
          placeholder="Выберите дату"
          format={USER_DATE_FORMAT}
          showToday={false}
        />
      </AppFormItem>
      <AppFormItem label="Тип даты" name="holiday" rules={formRules.required}>
        <AppSelect options={dateTypeOptions} />
      </AppFormItem>
      <AppFormItem label="Описание" name="description" rules={formRules.required}>
        <AppInput placeholder="Введите описание" />
      </AppFormItem>
    </AppForm>
  );
};
